// extracted by mini-css-extract-plugin
export default {"container":"PSDk","title":"l89u","chosenTitle":"ql4D","emptySections":"xP78"};